<script>
	export let name;

	import Emoji from "./Emoji.svelte";
	import Refraction from "./Refraction.svelte";

	let emojiComponent;
</script>

<Emoji bind:this={emojiComponent} />

<svelte:head>
<link href="https://fonts.googleapis.com/css?family=Carter+One&display=swap" rel="stylesheet">
</svelte:head>

<main>
	<div id = "container">
	<div id = "top">
		<div id = "intro">
			<!-- <div id = "splash"> welcome to the personal website of </div> -->
			<h1 id = "name">tommy li</h1>
		</div>
	</div>
	<div id = "projects">
	<div class = "project">
        <div class = "project-title"> Fun with refraction </div>
        <p> What's this strange piece of glass doing here? 
        Click and drag to see from different angles.</p>
	    <p>
	    <Refraction />
	    <i>Note: if you don't see anything or performance is slow, WebGL might not be enabled in your browser.</i></p>
	</div>
	<div class = "project">
		<div class = "project-title"> Wandering Cursor </div>
		<p>
		A little cursor navigates a world made of symbols. (Note: unfortunately a bit broken at the moment.)
		<a href = "https://yeahpython.github.io/game/game.html">
			<img class = "promo" src = "/images/ascii_2.png">
		</a>
		</p>
	</div>
	<div class = "project">
		<div class = "project-title"> Emoji pets </div>
		<p>
		Spawn a cute little emoji buddy by clicking here: <button on:click={() => emojiComponent.addEmoji() }>+</button>.
		Remove all emojis by clicking here: <button on:click={() => emojiComponent.removeAllEmojis() }>x</button>
		If you want more, try the <a href = "https://chrome.google.com/webstore/detail/emoji-pets/kmpienmlhgboooblifeplelmpaaccafc">
			Chrome extension</a>.
		  As a bonus, the emojis will be draggable in the extension! Icons are courtesy of Emojione.
		</p>
	</div>
	<div class = "project">
		<div class = "project-title"> Filter Anything Anywhere </div>
		<p>
		This is a
		<a href = "https://chrome.google.com/webstore/detail/filter-anything-everywher/jmandnadineideoebcmaekgaccoagnki">
			universal blacklist
		</a> to provide a little control over the content you consume.
		</p>
		<a href = "https://chrome.google.com/webstore/detail/filter-anything-everywher/jmandnadineideoebcmaekgaccoagnki">
			<img class="promo" src="/images/filter_anything_everywhere/fae-1.jpg">
			<img class="promo" src="/images/filter_anything_everywhere/fae-2.jpg">
			<img class="promo" src="/images/filter_anything_everywhere/fae-3.jpg">
		</a>
	</div>
	<div class = "project">
		<div class = "project-title"> Bees in a cave </div>
		<p>
		A fun project from high school that equipped little creatures with neural networks in a 2D world.
		<a href = "https://github.com/yeahpython/bees-bees-bees">
			<img class = "promo" src = "/images/bees.png">
		</a>
		</p>
	</div>
	</div>
</div>
</main>

<style>
	/*main {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}

	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}*/

main {
	font-family: sans-serif;
	/*height: 100%;*/
	padding: 0px;
}

#container {
	display: grid;
	grid-row-gap: 20px;
	grid-template-columns: 1fr minmax(100px, 800px) 1fr;
}

@media (max-width: 600px) {
#container {
	padding:8px;
}
}

@media (min-width: 600px) {
#container {
	padding:20px;
	grid-row-gap: 30px;
}
}

@media (min-width: 1220px) {
#container {
	grid-row-gap: 50px;
	padding: 50px;
}

}

#splash {
	color: white;
	font-size: 16pt;
}

#intro {
	vertical-align: middle;
	color: #a7f0ff;
	text-align: center;
	margin-top: 106px;
	padding-bottom: 24px;
	margin-bottom: 82px;
	background-color:#eb256f;
	display:block;
	max-width: 300px;
	margin-left: auto;
	margin-right: auto;
/*	padding-top:30px;
	margin-left: 30px;
	margin-right: 30px;*/
}

#personal-info {
	display:inline-block;
}

#top {
	grid-area: top;
	/*padding: 30px;*/
}

#links {
	grid-area: links;
}

#name {
	-webkit-margin-before: 0em;
	-webkit-margin-after: -1em;
	-webkit-margin-start: 0px;
	-webkit-margin-end: 0px;
	display: inline-block;
	/*width: 280px;  Needs to be wider than intro to have nice wrapping */
	margin-top: 0px;
	font-family: Carter One;
	font-size: 40pt;
	color: #ffd500;
}

a:link {
    color:#fff903;
	text-decoration: none;
}

a:visited {
	color:#9aff00;
}

#container {
	display: grid;
	grid-row-gap: 20px;
	grid-template-columns: 1fr minmax(100px, 800px) 1fr;
	grid-template-areas:
	   ". top ."
	   ". projects .";
}

#projects {
	grid-area: projects;
	display: grid;
	grid-template-columns: minmax(200px, 800px);
	grid-column-gap: 20px;
	grid-row-gap: 40px;
}

.promo {
	margin-left:auto;
	margin-right:auto;
	margin-top:6px;
	max-width:100%;
	display:block;
	border-radius: 12px;
}

.project-title {
	font-size:22pt;
	display:inline-block;
	font-weight: bold;
	/*color: #474f54*/
}

hr {
	height: 3px;
	border:none;
	background-color: #9b9b9b;
}

.project {
/*	display: inline-block;
	width: calc(100% - 60px);*/
	color: white;
	/*margin-top: 40px;*/
	font-size: 15pt;
	border-radius: 7px;
	/*background-color: #e1ffdd;*/
	padding: 10px;
}

@media (max-width: 420px) {
	.project {
		/*padding: 10px;*/
	}
}
@media (min-width: 420px) {
	.project {
		/*padding: 30px;*/
		/*border: solid 2px #e8e8e8;*/
	}
}

button {
	background-color: #ffe31f;
    color: black;
    /*border: none;*/
    border-radius: 20px;
    font-size: initial;
}

a:hover .project-title {
	color:#366bc1;
}

p {
	/*margin-top: 0px;*/
	/*margin-bottom: 0px;*/
}

</style>